// 单站监控
// 仅本地/局域网可见的菜单（如建筑节能模型）：线上域名不注册该路由，菜单与直达均不可见
// 放行：localhost、回环、私有地址段（10.* / 172.16~31.* / 192.168.*）、*.local
const _hostname = window.location.hostname
const isLocalHost =
  ['localhost', '127.0.0.1', '::1'].includes(_hostname) ||
  _hostname.endsWith('.local') ||
  /^(10|192\.168)\.\d{1,3}\.\d{1,3}(\.\d{1,3})?$/.test(_hostname) ||
  /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(_hostname)

export default {
  path: '/SingleStationMonitor',
  component: () => import('views/Layout.vue'),
  children: [
    // {
    //   path: 'Homepage',
    //   name: 'SingleStationHomepage',
    //   component: () => import('views/singleSiteMonitor/homepage.vue'),
    //   meta: {
    //     _meauname: '单站首页',
    //     keepAlive: true,
    //   },
    // },
    {
      path: 'HomepageCover',
      name: 'SingleStationHomepageCover',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '首页大屏',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/homepage/indexConfig.vue'),
      },
    },
    {
      path: 'SingleStationFaultAlarm',
      name: 'SingleStationFaultAlarm',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '单站故障告警',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "SingleStationFaultAlarm"*/ 'views/singleSiteMonitor/faultAlarm'),
      },
    },
    {
      path: 'SiteSettings',
      name: 'SiteSettings',
      children: [
        {
          path: 'DeviceManagement',
          name: 'DeviceManagement',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '设备管理',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "DeviceManagement"*/ 'views/singleSiteMonitor/siteSettings/deviceManagement'),
          },
        },
        {
          path: 'BasicInformation',
          name: 'BasicInformation',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '基础信息',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "BasicInformation"*/ 'views/singleSiteMonitor/siteSettings/basicInformation'),
          },
        },
        {
          path: 'ElectricityPriceManagement',
          name: 'ElectricityPriceManagement',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '电价管理',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "ElectricityPriceManagement"*/ 'views/singleSiteMonitor/siteSettings/electricityPrice'),
          },
        },
        {
          path: 'MeterTimeManagement',
          name: 'MeterTimeManagement',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '电表时段',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "MeterTimeManagement"*/ 'views/singleSiteMonitor/siteSettings/meterTimeManagement'),
          },
        },
        {
          path: 'SiteLog',
          name: 'SiteLog',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '站点日志',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "SiteLog"*/ 'views/singleSiteMonitor/siteSettings/siteLogs'),
          },
        },
        {
          path: 'SecondPassword',
          name: 'SecondPassword',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '二次口令',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "SecondPassword"*/ 'views/singleSiteMonitor/siteSettings/secondPassword'),
          },
        },
      ],
    },
    {
      path: 'EquipmentMonitor',
      name: 'SingleStationEquipmentMonitor',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '单站设备监控',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "SingleStationEquipmentMonitor"*/ 'views/singleSiteMonitor/equipmentMonitor'),
      },
    },
    {
      path: 'SystemMonitoring',
      name: 'SystemMonitoring',
      children: [
        {
          path: 'PowerDistribution',
          name: 'PowerDistribution',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '配用电系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "PowerDistribution"*/ 'views/singleSiteMonitor/SystemMonitoring/PowerDistribution'),
          },
        },
        {
          path: 'SystemOverview',
          name: 'SystemOverview',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '站点系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "DeviceManagement"*/ 'views/singleSiteMonitor/SystemMonitoring/SystemOverview/index'),
          },
        },
        {
          path: 'ChargingSystem',
          name: 'ChargingSystem',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '充电系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "DeviceManagement"*/ 'views/singleSiteMonitor/SystemMonitoring/ChargingSystem'),
          },
        },
        {
          path: 'EnergyStorageSystem',
          name: 'EnergyStorageSystem',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '储能系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "DeviceManagement"*/ 'views/singleSiteMonitor/SystemMonitoring/EnergyStorageSystem'),
          },
        },
        {
          path: 'PhotovoltaicSystem',
          name: 'PhotovoltaicSystem',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '光伏系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "DeviceManagement"*/ 'views/singleSiteMonitor/SystemMonitoring/PhotovoltaicSystem'),
          },
        },
        {
          path: 'OtherLoadsSystem',
          name: 'OtherLoadsSystem',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '其它负荷系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "OtherLoadsSystem"*/ 'views/singleSiteMonitor/SystemMonitoring/OtherLoadsSystem'),
          },
        },
        {
          path: 'FanSystem',
          name: 'FanSystem',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '风力系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "FanSystem"*/ 'views/singleSiteMonitor/SystemMonitoring/FanSystem'),
          },
        },
        {
          path: 'AirConditionSystem',
          name: 'AirConditionSystem',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '空调系统概览',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "AirConditionSystem"*/ 'views/singleSiteMonitor/SystemMonitoring/FanSystem'),
          },
        },
        {
          path: 'VideoSurveillance',
          name: 'VideoSurveillance',
          component: () => import('@/views/webview.vue'),
          meta: {
            _meauname: '视频监控',
            keepAlive: true,
            defaultComponent: () => import(/*webpackChunkName: "VideoSurveillance"*/ 'views/singleSiteMonitor/SystemMonitoring/videoSurveillance'),
          },
        },
      ],
    },
    {
      path: 'CurveReport',
      name: 'CurveReport',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '曲线报表',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/CurveReport.vue'),
      },
    },
    {
      path: 'WiringDiagram',
      name: 'WiringDiagram',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '拓扑图',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/wiringDiagram/index.vue'),
      },
    },
    {
      path: 'AirCondition',
      name: 'AirCondition',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '系统图',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/airCondition/index.vue'),
      },
    },
    {
      path: 'BatteryDiagnostic',
      name: 'BatteryDiagnostic',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '电池检测',
        keepAlive: true,
        defaultComponent: () => import('views/singleSiteMonitor/batteryDiagnostic/index.vue'),
      },
      redirect: '/SingleStationMonitor/BatteryDiagnostic/BatteryDiagnosticList',
      children: [
        {
          path: 'BatteryDiagnosticList',
          name: 'BatteryDiagnosticList',
          component: () => import('@/views/webview.vue'),
          meta: {
            keepAlive: true,
            hide: true,
            skipPermission: true,
            defaultComponent: () => import('views/singleSiteMonitor/batteryDiagnostic/list.vue'),
          },
        },
        {
          path: 'BatteryDiagnosticRecord',
          name: 'BatteryDiagnosticRecord',
          component: () => import('@/views/webview.vue'),
          meta: {
            keepAlive: true,
            hide: true,
            skipPermission: true,
            _meauname: '电池检测记录',
            defaultComponent: () => import('views/singleSiteMonitor/batteryDiagnostic/record.vue'),
          },
        },
        {
          path: 'BatteryServiceRecord',
          name: 'BatteryServiceRecord',
          component: () => import('@/views/webview.vue'),
          meta: {
            keepAlive: true,
            hide: true,
            skipPermission: true,
            _meauname: '电池保养历史记录',
            defaultComponent: () => import('views/singleSiteMonitor/batteryDiagnostic/record.vue'),
          },
        },
        {
          path: 'BatteryDiagnosticResult',
          name: 'BatteryDiagnosticResult',
          component: () => import('@/views/webview.vue'),
          meta: {
            keepAlive: true,
            hide: true,
            skipPermission: true,
            _meauname: '电池检测结果',
            defaultComponent: () => import('views/singleSiteMonitor/batteryDiagnostic/result.vue'),
          },
        },
        {
          path: 'BatteryPdf',
          name: 'BatteryPdf',
          component: () => import('@/views/webview.vue'),
          meta: {
            keepAlive: true,
            hide: true,
            skipPermission: true,
            _meauname: '电池保养算法说明书',
            defaultComponent: () => import('views/singleSiteMonitor/batteryDiagnostic/pdf.vue'),
          },
        },
        {
          path: 'BatteryDiagnosticCharts',
          name: 'BatteryDiagnosticCharts',
          component: () => import('@/views/webview.vue'),
          meta: {
            keepAlive: true,
            hide: true,
            skipPermission: true,
            _meauname: '电池检测图表',
            defaultComponent: () => import('views/singleSiteMonitor/batteryDiagnostic/charts.vue'),
          },
        },
      ],
    },
    // 建筑节能模型：仅本地调试，线上不注册（见文件顶部 isLocalHost）
    ...(isLocalHost
      ? [
          {
            path: 'BuildingEnergyModel',
            name: 'BuildingEnergyModel',
            component: () => import('@/views/webview.vue'),
            meta: {
              _meauname: '建筑节能模型',
              keepAlive: true,
              skipPermission: true,
              defaultComponent: () => import('views/singleSiteMonitor/buildingEnergyModel/index.vue'),
            },
          },
        ]
      : []),
    // {
    //   path: 'DataReport',
    //   name: 'DataReport',
    //   component: () => import('@/views/webview.vue'),
    //   meta: {
    //     _meauname: '数据报表',
    //     keepAlive: true,
    //     skipPermission: true,
    //     icon: 'icon-shujubaobiao',
    //     defaultComponent: () => import('views/singleSiteMonitor/dataReport/index.vue'),
    //   },
    // },
  ],
}
